import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import { resolveColorContext, type ContextFamily } from '@quipex/shared/utils';
import { QpxButton } from '../../directives';

@Component({
    selector: 'qpx-switch',
    imports: [QpxButton],
    templateUrl: './switch.html',
    styleUrl: './switch.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'inline-flex shrink-0',
        '[style.--qpx-switch-on-color]': 'onColor()',
    },
})
export class QpxSwitch {
    //#region Inputs
    public readonly checked = input.required<boolean>();
    /** Family that colours the track while on. */
    public readonly context = input<ContextFamily>('primary');
    /** Accessible name when no visible label element exists. */
    public readonly label = input<string>();
    public readonly labelledBy = input<string>();
    public readonly describedBy = input<string>();
    /** Stays focusable while disabled so keyboard focus survives async work. */
    public readonly disabled = input(false);
    //#endregion

    //#region Outputs
    /** Emits the requested value; the owner decides whether to apply it. */
    public readonly toggled = output<boolean>();
    //#endregion

    //#region State
    protected readonly onColor = computed(
        () => `var(${resolveColorContext(this.context()).decorative.variable})`
    );
    //#endregion

    protected onClick(): void {
        if (this.disabled()) return;
        this.toggled.emit(!this.checked());
    }
}
